<template>
  <div>
    <el-container style="height: 100vh;">
      <el-aside width="auto">
        <!-- <img style="width: 150px;display: block;margin: 3px auto;" src="../../assets/images/xinsanxinlogoin.png" alt=""> -->
        <div style="display:flex;justify-content: center;">
          <img style="width: 45px;display: block;justify-content: center;" src="../../assets/images/shuxiang.png"
            alt="">
          <h1 style="height:10px;line-height:60px">云田购</h1>
        </div>

        <el-menu :default-active="$route.path" style="background-color:#fff" class="el-menu-vertical-demo" router :unique-opened="true" @select="handleSelect">
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-news"></i>
              <span>线上选书处理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/shoppingList">
                <span slot="title">购物车汇总</span>
              </el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group>
              <el-menu-item index="/orderListSet">
                <span slot="title">订单汇总</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-wind-power"></i>
              <span>荐购处理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/jgcl">
                <span slot="title">一般荐购处理</span>
              </el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group>
              <el-menu-item index="/jgclcopy">
                <span slot="title">荐购直邮处理</span> 
              </el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group>
              <el-menu-item index="/jgOrderList">
                <span slot="title">荐购订单汇总</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">
              <i class="el-icon-edit"></i>
              <span>荐购记录</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/jgjl">
                <span slot="title">一般荐购记录</span>
              </el-menu-item>
              <el-menu-item index="/jgjlcopy">
                <span slot="title">荐购直邮记录</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item index="/noBooklist">
            <i class="el-icon-reading"></i>
            <span slot="title">无书目荐购</span>
          </el-menu-item>
          <el-menu-item index="/borrowManage">
            <i class="el-icon-receiving"></i>
            <span slot="title">借阅管理</span></span>
          </el-menu-item>
          <el-menu-item index="/userManage">
            <i class="el-icon-user"></i>
            <span slot="title">用户管理</span>
            <!-- <span slot="title">会员分组</span> -->
          </el-menu-item>
          <el-submenu index="4">
            <template slot="title">
              <i class="el-icon-setting"></i>
              <span>荐购规则设置</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/jgsd">
                <i class="el-icon-setting"></i>
                <span slot="title">一般荐购规则</span>
              </el-menu-item>
              <el-menu-item index="/jgzysd">
                <i class="el-icon-setting"></i>
                <span slot="title">荐购直邮规则</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item index="/systemSet">
            <i class="el-icon-set-up"></i>
            <span slot="title">系统设置</span>
          </el-menu-item>
          <!-- <el-menu-item index="/deployGuide">
            <i class="el-icon-document"></i>
            <span slot="title">部署流程说明</span>
          </el-menu-item> -->
          <el-menu-item index="/libRank">
            <i class="el-icon-office-building"></i>
            <span slot="title">图书馆访问统计</span>
          </el-menu-item>
          <el-submenu index="5">
            <template slot="title">
              <i class="el-icon-truck"></i>
              <span>物流统计</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/Bookallocationrate">
                <span slot="title">配书率</span>
              </el-menu-item>
              <el-menu-item index="/Bookpublishingrate">
                <span slot="title">发书率</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item index="/ImportCol">
            <i class="el-icon-reading"></i>
            <span slot="title">馆藏导入</span>
          </el-menu-item>
          <!-- <el-menu-item index="/similarLibrary">
            <i class="el-icon-data-analysis"></i>
            <span slot="title">同类馆参考</span>
          </el-menu-item>
          <el-menu-item index="/orgMarc">
            <i class="el-icon-document-checked"></i>
            <span slot="title">MARC数据校验</span>
          </el-menu-item> -->
        </el-menu>

      </el-aside>
      <el-container>
        <el-header>
          <top-component ref="topRef"></top-component>

        </el-header>
        <el-main>
          <div style="width:calc(100% - 15px);min-height:98%;background-color:#fff;border-radius:5px;padding:7px;">
            <router-view></router-view>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import TopComponent from '../Components/TopComponentcopy.vue'

export default {
  data () {
    return {
      lujing: '/jgcl'
    }
  },
  components: {
    TopComponent,
  },
  methods: {
    handleSelect (key, keyPath) {
      // this.lujing = key
    }
  }

}
</script>
<style>
.el-header,
.el-footer {
  background-color: #fff;
  color: #333;
  padding: 0;
}

.el-aside {
  overflow: auto;
  background-color: #fff;

}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.el-main {
  background-color: #e9eef3;
  color: #333;
  padding: 5px;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
.el-pagination{
    text-align: right;
    padding-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/Xtch/Xht.vue